<ng-container [formGroup]="formGroupCampaignTypeData">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Ask for item category" formControlName="askForCategory"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Ask donors to enter the category or categories their item belongs to."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Ask for item description" formControlName="askForDescription"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Ask donors for a description of the item they are donating."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Ask for images of item" formControlName="askForImages"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Ask donors for images of the item."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
</ng-container>